import { Icon } from "@iconify/react";

const navConfig = [
  {
    id: 1,
    title: "Send Mail",
    path: "/sendmail",
    icon: <Icon icon="mdi:view-dashboard-outline" width="20" height="20" />,
  },
  {
    id: 2,
    title: "Add User",
    path: "/addUser",
    icon: <Icon icon="wpf:adduser" width="20" height="20" />,
  },
  {
    id: 3,
    title: "Add Company Name",
    path: "/companydetails",
    icon: <Icon icon="pajamas:details-block" width="20" height="20" />,
  },
  {
    id: 3,
    title: "Company Status",
    path: "/changestatus",
    icon: <Icon icon="fluent-mdl2:sync-status-solid" width="20" height="20" />,
  },
];

export { navConfig };
